import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";

import { FontAwesomeIcon } from "../../shared/FontAwesomeIconWrapper";

class ToggleMiraSpeaking extends PureComponent {
	render() {
		return (
			<div style={{ alignItems: "center", justifyContent: "center", marginLeft: "8px", marginRight: "8px", cursor: "pointer" }} onClick={this.props.onPress}>
				<div style={{ color: this.props.miraSpeaking ? "lightgreen" : "white" }}>
					<FontAwesomeIcon icon="assistive-listening-systems" />
				</div>
			</div>
		);
	}
}

export default branch({
	miraSpeaking: ["miraSpeaking"]
}, ToggleMiraSpeaking);